(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["img-gallery"] && !Shopify.designMode) return;
  try {
    
  // DT-0: bloque deshabilitado temporalmente (2026-09-04).
  // El código original de este lightbox hacía referencia a variables nunca
  // declaradas en este archivo (modal, images, currentIndex, showModal) y
  // terminaba con un "})()" huérfano, lo que producía:
  //   "Uncaught SyntaxError: Missing catch or finally after try"
  // en scripts.js (Shopify combina este bloque con otros assets del tema).
  // Se vació el bloque para eliminar el error de consola sin adivinar la
  // implementación original. El modal/lightbox de esta sección de galería
  // (clases .mw-modal, .mw-modal-prev, .mw-modal-next, #mw-modal-image)
  // queda pendiente de reconstruir como tarea aparte.

  } catch(e) { console.error(e); }
})();
})();
